export default "__VITE_ASSET__BUVp4Au6__"